module.exports = __webpack_public_path__ + "static/screenshot-0e727d773230ab55552e7dd2d7c34658.gif";